import { UserRole } from '~/types/Users';
export function mapOktaUserToUser(userData) {
    let firstName = '';
    if (typeof userData.given_name === 'string' && userData.given_name) {
        firstName = userData.given_name;
    }
    else if (typeof userData.name === 'string' && userData.name) {
        firstName = userData.name;
    }
    return {
        userId: typeof userData.sub === 'string' ? userData.sub : '',
        email: typeof userData.email === 'string' ? userData.email : '',
        firstName,
        lastName: typeof userData.family_name === 'string' ? userData.family_name : '',
        userType: UserRole.DEV, // Default for now; in future map from claims/AD group
        role: typeof userData.role === 'string' ? userData.role : '',
        org: typeof userData.org === 'string' ? userData.org : '',
        fullName: typeof userData.name === 'string' ? userData.name : ''
    };
}
